import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { MAX_NUMBER_OF_THUMBNAILS } from './constants';
import { controlStyles } from './mixins.styled';
const CONTROL_CONTAINER_POSITION_OFFSET = 20;
/**
 * Gallery next
 */
export const galleryNextStyles = ({ theme }) => css `
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	right: ${pxToRem(theme.spacing['300'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		right: ${pxToRem(theme.spacing['400'])};
	}
`;
export const GalleryNext = styled.label `
	${controlStyles}
	${galleryNextStyles}
`;
/**
 * Gallery previous
 */
export const galleryPreviousStyles = ({ theme }) => css `
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	left: ${pxToRem(theme.spacing['300'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		left: ${pxToRem(theme.spacing['400'])};
	}
`;
export const GalleryPrevious = styled.label `
	${controlStyles}
	${galleryPreviousStyles}
`;
/**
 * Gallery sliders
 */
export const gallerySlidersContainerStyles = () => css `
	grid-area: slide;
	-ms-grid-row: 1;
	-ms-grid-column: 1;
	-ms-grid-column-span: ${MAX_NUMBER_OF_THUMBNAILS + 2};
	display: block;
	position: absolute;
	width: 100%;
	top: calc(50% - ${pxToRem(CONTROL_CONTAINER_POSITION_OFFSET)});
	pointer-events: none;

	::selection {
		background: transparent;
	}
`;
export const GallerySlidersContainer = styled.div `
	${gallerySlidersContainerStyles}
`;
//# sourceMappingURL=gallery-sliders.styled.js.map